import { render, staticRenderFns } from "./DialogBankAccount.vue?vue&type=template&id=10c2d0e7&"
import script from "./DialogBankAccount.vue?vue&type=script&lang=js&"
export * from "./DialogBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports